import React from "react";
import styles from "./index.module.scss";
export default class FormHeader extends React.Component {
    render() {
        return React.createElement("h2", { className: styles.header }, this.props.children);
    }
}
